import { Examples } from '@/types';

export const ExampleDocumentEmailToMeModalRoutes =
  process.env.NODE_ENV !== 'production'
    ? [
      {
        ...Examples.ExampleDocumentEmailToMeModal,
        components: {
          default: () => import(/* webpackChunkName: "ExampleDocumentEmailToMeModal" */ 
          '@/views/examples/ExampleDocumentEmailToMeModal.vue')
        }
      }
    ]
    : [];